import React from 'react';
import { TypedMemo } from '../../../common/types';
import { usePageTabsOnTop } from './usePageTabsOnTop';

/**
 * The page tabs in the page body (desktop). On a phone `SMLPageHead` shows the same tabs at its
 * top, so this part shows nothing there: the tabs render one time.
 */
const PageTabsInBodyComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const onTop = usePageTabsOnTop();
  return onTop ? null : <>{children}</>;
};

export const PageTabsInBody = TypedMemo(PageTabsInBodyComponent);
